import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setUndoRedoCommand } from '../../../redux/operationSlice';

/**
 * useUndo Hook
 *
 * Redux'taki undoRedoCommand state'ini dinler.
 * 'UNDO' komutu geldiğinde, global undoRedoManager üzerinden
 * undo işlemini gerçekleştirir ve zinciri ilerletir.
 *
 * @param {THREE.Scene} scene - Three.js sahne nesnesi
 * @param {object} options - Ek ayarlar
 * @param {React.MutableRefObject} options.undoRedoManagerRef - UndoRedoManager ref'i
 */
export function useUndo(scene, options = {}) {
  const dispatch = useDispatch();
  const undoRedoCommand = useSelector(state => state.operation.undoRedoCommand);

  useEffect(() => {
    if (undoRedoCommand !== 'UNDO') return;

    const undoRedoManager = options.undoRedoManagerRef?.current ||
                           (typeof window !== 'undefined' ? window.undoRedoManager : null);

    if (!undoRedoManager) {
      dispatch(setUndoRedoCommand('NONE'));
      return;
    }

    // Global undo işlemi
    try {
      undoRedoManager.undo(scene, dispatch);
    } catch (err) {
      // UNDO failed
    }

    // Komutu sıfırla
    dispatch(setUndoRedoCommand('NONE'));

  }, [undoRedoCommand, scene, dispatch, options.undoRedoManagerRef]);
}
